/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */

/**
 * 이벤트 상태
 */
export type WorldcupEventDtoStatus = (typeof WorldcupEventDtoStatus)[keyof typeof WorldcupEventDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorldcupEventDtoStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
} as const;
